import React, { useMemo } from "react";
import {
  HStack,
  Icon,
  Menu,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { CURRENCIES } from "../../balanceSheetConstants";
import {
  getRangeOptions,
  isCustomRangeValue,
} from "../../Shared/Utils/dateRanges";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";
import CashFlowMainFilterPopover from "./CashFlowMainFilterPopover";

export default function CashFlowFilters({
  filters,
  dateRangeLabel,
  onSelectRange,
  onOpenCustomRange,
  onApplyFilters,
  onCurrencyChange,
  texts,
}) {
  const rangeOptions = useMemo(() => getRangeOptions(texts), [texts]);

  const selectedCurrency =
    CURRENCIES.find((currency) => currency.code === filters.currency) ||
    CURRENCIES[1];
  return (
    <HStack spacing={1}>
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text fontSize="xs">{selectedCurrency.code} {selectedCurrency.symbol}</Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList} maxHeight="250px" overflowY="auto">
          {CURRENCIES.map((currency) => (
            <MenuItem
              key={currency.code}
              onClick={() => onCurrencyChange(currency.code)}
              py={1}
              fontSize="xs"
            >
              {currency.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text fontSize="xs">{dateRangeLabel}</Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList} maxHeight="250px" overflowY="auto">
          {rangeOptions.map((range) => (
            <MenuItem
              key={range.value}
              onClick={() =>
                isCustomRangeValue(range.value)
                  ? onOpenCustomRange()
                  : onSelectRange(range.value)
              }
              py={1}
              fontSize="xs"
            >
              {range.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <CashFlowMainFilterPopover
        initialFilters={filters}
        onApplyFilters={onApplyFilters}
        texts={texts}
      />
    </HStack>
  );
}
